import { useState } from "react";
import { useAuth, useOrderOption } from "../../hooks";
import { CustomerModal } from "..";
import { OrderType } from "../../enums";
import { CircleFill, Pencil } from "react-bootstrap-icons";
import { FaUserAlt } from "react-icons/fa";

type Props = {
  className?: string;
};

const CartUser: React.FC<Props> = ({ className = "" }) => {
  const { orderOption } = useOrderOption();
  const { customer } = useAuth();
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <div className={`choose_payment_address ${className}`}>
        <div className="d-flex justify-content-between align-items-start">
          <div className="d-flex">
            <FaUserAlt className="mx-2 mt-1 icon-style2" size={18} />

            <div>
              <h5>
                {customer?.first_name} {customer?.last_name}{" "}
                <span>
                  (
                  {orderOption.type_id == OrderType.DELIVERY
                    ? "Delivery"
                    : orderOption.type_id == OrderType.PICKUP
                      ? "Pickup"
                      : orderOption.type_id == OrderType.DINEIN
                        ? "Dine In"
                        : orderOption.type_id == OrderType.GIFTCARD
                          ? "Giftcard"
                          : ""}
                  )
                </span>
              </h5>
              <p>
                {customer?.phone} <CircleFill size={4} className="mx-1" />{" "}
                {customer?.email}
              </p>
            </div>
          </div>
          <button
            onClick={() => setShowModal(true)}
            className="delete_btn edit-user-btn d-flex justify-content-center align-items-center"
          >
            <Pencil />
          </button>
        </div>
      </div>

      <CustomerModal
        show={showModal}
        handleClose={handleClose}
        handleSuccess={handleClose}
      />
    </>
  );
};

export default CartUser;
